module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-dagen-kiezen page",
    attrs: {
      "id": "page-dagen-kiezen"
    }
  }, [_c('div', {
    staticClass: "page__content container"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("ALS HYBRIDE DOCENT ZUL JE KEUZES MOETEN MAKEN OVER DE INDELING VAN JE WERKWEEK")]), _vm._v(" "), _c('p', [_vm._v("Hoeveel dagen wil je in beide banen werken?")]), _vm._v(" "), _c('div', {
    staticClass: "days-select"
  }, [_c('div', {
    staticClass: "days-select__title"
  }, [_vm._v("1. Huidige baan")]), _vm._v(" "), _c('div', {
    staticClass: "days-select__job"
  }, [_vm._v(_vm._s(_vm.getJobDescrption(_vm.userProfile.baan1)))]), _vm._v(" "), _vm._l((_vm.nmbDays), function(nmb) {
    return _c('div', {
      staticClass: "days-select__day",
      class: _vm.daysClass(0, nmb),
      on: {
        "click": function($event) {
          _vm.selectType(0, nmb)
        }
      }
    }, [_vm._v(_vm._s(nmb))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "days-select"
  }, [_c('div', {
    staticClass: "days-select__title"
  }, [_vm._v("2. Nieuwe baan")]), _vm._v(" "), _c('div', {
    staticClass: "days-select__job"
  }, [_vm._v(_vm._s(_vm.getJobDescrption(_vm.userProfile.baan2)))]), _vm._v(" "), _vm._l((_vm.nmbDays), function(nmb) {
    return _c('div', {
      staticClass: "days-select__day",
      class: _vm.daysClass(1, nmb),
      on: {
        "click": function($event) {
          _vm.selectType(1, nmb)
        }
      }
    }, [_vm._v(_vm._s(nmb))])
  })], 2), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.submitDays()
      }
    }
  }, [_vm._v("Volgende")])]), _vm._v(" "), (!_vm.validCombination && _vm.daysSubmitted) ? _c('p', {
    staticClass: "error-panel"
  }, [_vm._v("\n            Kies voor elke baan minstens 1 dag in de week\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "result-anchor"
  }), _vm._v(" "), (_vm.validCombination && _vm.daysSubmitted) ? _c('div', {
    staticClass: "result-box"
  }, [_c('p', [_vm._v(_vm._s(_vm.result))]), _vm._v(" "), _c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__icon-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05de1008","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-dagen-kiezen.vue
// module id = 133
// module chunks = 0